@if (error) {
  @if (error.errorCode === '400.102.014') {
    <app-card [errorSubtitle]="'credential.error_not_found' | translate"></app-card>

    <p class="text-sm text-gray-600 dark:text-gray-400 leading-relaxed">
      {{ 'credential.error_not_found_description' | translate }}
    </p>
  } @else if (error.errorCode === 'provider') {
    <app-card [title]="credentialInfo?.title"
              [errorSubtitle]="'credential.error_provider' | translate"
              [image]="credentialInfo?.card"></app-card>

    <p class="text-sm text-gray-600 dark:text-gray-400 leading-relaxed pb-4">
      {{ 'credential.error_provider_description' | translate }}
    </p>

    <button type="button"
            (click)="onRetryAfterProviderError()"
            class="w-auto px-10 py-2 bg-gray-600 hover:bg-gray-700 rounded-md text-white font-semibold transition-colors">
      {{ 'mfa.btn_retry' | translate }}
    </button>
  } @else {
    <app-card [errorSubtitle]="'credential.error_unknown' | translate : {code: error.errorCode}"></app-card>
  }
} @else {
  <app-card [title]="credentialInfo?.title"
            [subtitle]="credentialInfo?.subtitle ?? '&nbsp;'"
            [errorSubtitle]="credentialInfo?.errorSubtitle"
            [image]="credentialInfo?.card"
            [loading]="credentialInfo === undefined"></app-card>

  @if (redemptionInfo?.status === 'AVAILABLE') {

    @if (credentialInfo && credentialInfo.deployable && redemptionInfo) {
      @if (platform.isAndroid()) {
        <app-platform-android [redemptionInfo]="redemptionInfo"
                              [credentialInfo]="credentialInfo"
                              (providerError)="onProviderError($event)"></app-platform-android>
      } @else if (platform.isIPhone()) {
        <app-platform-ios [redemptionInfo]="redemptionInfo"
                          [credentialInfo]="credentialInfo"
                          (providerError)="onProviderError($event)"></app-platform-ios>
      } @else {
        <p class="text-gray-500 font-medium">
          {{ 'credential.device_unsupported' | translate }}
        </p>
      }
    } @else {
      @if (platform.isMobile()) {
        <p class="text-gray-500 font-medium">
          {{ 'credential.device_unsupported' | translate }}
        </p>
      } @else {
        <app-platform-desktop [credentialKey]="credentialKey"></app-platform-desktop>
      }
    }

  } @else if (redemptionInfo?.status === 'UNAVAILABLE') {
    <p class="text-gray-500 font-medium">
      {{ 'credential.credential_unavailable' | translate }}
    </p>
  } @else if (redemptionInfo?.status === 'MFA_REQUIRED' && credentialKey) {
    @if (platform.isMobile()) {
      <app-mfa [credentialKey]="credentialKey"
               (redemptionInfo)="onRedemptionInfoMfaResult($event)"></app-mfa>
    } @else {
      <app-platform-desktop [credentialKey]="credentialKey"></app-platform-desktop>
    }
  } @else if (redemptionInfo?.status === 'SSO_REQUIRED') {
    <p class="text-gray-500 font-medium">
      {{ 'credential.sso_not_supported' | translate }}
    </p>
  }

  <p class="text-sm text-gray-600 dark:text-gray-400 leading-relaxed pt-4">
    {{ 'credential.warning' | translate }}
  </p>

<!--    <p class="text-gray-500 font-medium pt-8">-->
<!--        DEPLOYABLE: {{ credentialInfo?.deployable }}<br/>-->
<!--        PROVIDER: {{ credentialInfo?.provider }}<br/>-->
<!--        {{ redemptionInfo | json }}-->
<!--      </p>-->
}

